define('app/leaflet-extensions/leaflet-centered-icon',['leaflet'], function(L) {
  'use strict';

  /*
   * Extension of standard Leaflet Icon class with automatic centering of icon.
   *
   * (without needing to specify the size)
   */
  L.Icon.Centered = L.Icon.extend({
    _setIconStyles: function(img, name) {
      var resizeFactor = this.options.resizeFactor || 1;

      img.style.visibility = 'hidden';
      img.onload = function() {
        img.style.width = img.width * resizeFactor + 'px';
        img.style.height = 'auto';
        var anchor = L.point([img.width, img.height]).divideBy(2, true);
        img.style.marginLeft = -anchor.x + 'px';
        img.style.marginTop = -anchor.y + 'px';
        img.style.visibility = 'visible';
      };
    },
  });

  // Creates an icon instance with the given options.
  L.centeredIcon = function(options) {
    return new L.Icon.Centered(options);
  };
});

